import React, { useState } from 'react';
import { Result, Button, } from 'antd';
import { Navigate } from 'react-router-dom';
import { PUBLIC_ROUTE } from '@router/route.constants';
import { useTranslation } from 'react-i18next';
import { NotFoundFilled } from '@assets';

const Page404 = () => {
  const { t } = useTranslation()
  const [redirectReferer, setRedirectReferer] = useState(false);

  const back = () => {
    setRedirectReferer(true);
  }

  if (redirectReferer) {
    return <Navigate to={`/${PUBLIC_ROUTE.HOME}`} replace />
  }

  return (
    <Result
      title="404"
      subTitle={t("error.subtitle404")}
      icon={<NotFoundFilled />}
      extra={
        <Button
          type="primary"
          onClick={back}
        >
          {t("error.backHome")}
        </Button>
      }
    />
  );
}

export default Page404;